import { connectWallet, signMessageAndSend } from "./blockchain/walletService";
import { sendEmailCode, verifyEmailCode } from "./data_requests";
export * from "./data_requests";

export const blockchainfeatures = {
  connectWallet,
  signMessageAndSend,
};

export const bdRequests = {
  sendEmailCode,
  verifyEmailCode,
};
